define('views/app/member',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'collections/member/supervisors',
    // layouts
    'views/app/base-layout',
    'views/app/member/member',
    'views/modules/dashboard/dashboard',
    // views
    'views/modules/conversation/conversation-manager',
    'views/app/member/setting/setting-panel',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    Supervisors,
    // Layouts
    VBaseLayout,
    VAppMember,
    VDashboard,
    // views
    VConversationManager,
    VMemberSettingPanel
) {

    var VMemberLayout = VBaseLayout.extend({
        initialize: function(opt) {
            this.view = { menu: {} };
            this.url = _.mapObject(this.url, function(val, key) {
                return key === 'message' ? val : Mustache.render(val, { userId: 'me' });
            });
        },

        menu: {
            profile: function() {
                return [
                    { content: 'Go to Supervisor', route: '#/supervisor', icon: 'sl-icon-login', id: 'layoutSwitch' },
                    { content: 'Edit my profile', callback: this.onEditProfileAction, icon: 'sl-icon-user' },
                    { content: 'Log out', callback: this.onLogoutAction, icon: 'sl-icon-power' },
                ];
            },
            primary: function() {
                var url = this.url;
                return [
                    { content: 'Dashboard', route: '#/' + url.dashboard, icon: 'sl-icon-speedometer', id: 'dashboard' },
                    { content: 'calendar:Calendar', icon: 'sl-icon-calendar', route: '#/' + url.calendar, id: 'calendar' },
                    { content: 'Messages', callback: this.showConversationMenu, icon: 'sl-icon-envelope', id: 'message' /* badge: '5' */ },
                    { content: 'goal:Goals', route: '#/' + url.goal, icon: 'sl-icon-flag', id: 'goal' },
                    { content: 'graph:Graph', route: '#/' + url.graph, icon: 'sl-icon-pie-chart', id: 'graph' },
                    /* { content: 'Forums', route: '#/' + url.forum, icon: 'sl-icon-bubbles' }, */
                    { content: 'Settings', callback: this.showSettingMenu, icon: 'sl-icon-settings', id: 'setting' },
                    { icon: 'sl-icon-question', content: 'Help', callback: this.showHelpMenu, id: 'help' }
                ];
            }
        },

        getMemberView: function() {
            var view = this.view.page;
            return view || (this.view.page = new VAppMember(this.getViewOptions()));
        },
        //////////
        // page //
        //////////
        showMemberPage: function(groupId, userId, pageKey, options) {
            var view = this.view.page;

            view = this.view.page || (this.view.page = new VAppMember(this.getViewOptions()));

            this.when(
                this.setMemberId(userId),
                this.setGroupId(groupId),
                this.newConversations.getFirstPage({ unread: true }),
                User.fetch(),
                Supervisors.fetch()
            ).then(function() {
                this.getContent().setView(view, true);
                view.showPage(pageKey, options);
            });

            return this;
        },

        showDashboard: function(groupId, userId) {
            var view = this.view.dashboard;

            view = this.view.dashboard || (this.view.dashboard = new VDashboard(this.getViewOptions()));

            this.when(
                this.setMemberId('me'),
                this.setGroupId(groupId),
                this.newConversations.getFirstPage({ unread: true }),
                User.fetch(),
                Supervisors.fetch()
            ).then(function() {
                this.getContent().setView(view, true);
            });
        },

        getViewOptions: function() {
            return {
                model: this.profile,
                url: _.clone(this.url),
                group: this.getGroup(),
                role: this.role,
            };
        },

        //////////
        // menu //
        //////////

        showCalendar: function() {
            this.showPage('calendar');
        },

        showConversationMenu: function() {
            var primaryMenu = this.getMenu().getPrimary(),
                messageItem = primaryMenu.findItem('message');

            if (!this.view.message) {
                this.view.message = new VConversationManager({
                    model: this.profile,
                    group: this.getGroup(),
                    url: this.url.message,
                    role: this.role,
                });
            }
            this.setMenuDrawerContent(this.view.message);
        },

        showSettingMenu: function() {
            if (!this.view.param) {
                this.view.param = new VMemberSettingPanel({
                    model: this.profile,
                    group: this.getGroup(),
                    url: this.url.member,
                    role: this.role,
                });
            }

            this.setMenuDrawerContent(this.view.param);
        },

        onEditProfileAction: function() {
            this.showSettingMenu();
        },

    });

    return VMemberLayout;
});

